"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  font-size: 1rem;\n  line-height: 1.6rem;\n  text-transform: uppercase;\n  color: ", ";\n  cursor: pointer;\n\n  &:hover {\n    color: black;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  border-bottom: 0.5px solid #d2d2d2;\n  padding-bottom: 13px;\n  align-items: flex-end;\n  margin-bottom: 13px;\n\n  .title {\n    font-weight: bold;\n    font-size: 1.6rem;\n    line-height: 130%;\n    color: ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  font-family: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var CollapsibleSidebar = function CollapsibleSidebar(_ref) {
  var label = _ref.label,
      children = _ref.children,
      open = _ref.open;

  var _useState = (0, _react.useState)(open),
      _useState2 = _slicedToArray(_useState, 2),
      SideBarOpen = _useState2[0],
      setSideBarOpen = _useState2[1];

  var handleToggle = function handleToggle() {
    setSideBarOpen(!SideBarOpen);
  };

  return _react.default.createElement(Sidebar, null, _react.default.createElement(SidebarHeader, null, _react.default.createElement("span", {
    className: "title"
  }, label), _react.default.createElement(SidebarToggle, {
    onClick: handleToggle
  }, SideBarOpen ? 'Hide' : 'Show')), _react.default.createElement(SidebarContent, {
    open: SideBarOpen
  }, children));
};

var Sidebar = _styledComponents.default.div(_templateObject(), function (_ref2) {
  var theme = _ref2.theme;
  return theme.font;
});

var SidebarHeader = _styledComponents.default.div(_templateObject2(), function (_ref3) {
  var theme = _ref3.theme;
  return theme.typo.subTitle;
});

var SidebarContent = _styledComponents.default.div(_templateObject3(), function (_ref4) {
  var open = _ref4.open;
  return open ? 'block' : 'none';
});

var SidebarToggle = _styledComponents.default.a(_templateObject4(), function (_ref5) {
  var theme = _ref5.theme;
  return theme.brand.primary;
});

CollapsibleSidebar.propTypes = {
  /** Label to be displayed at the top. */
  label: _propTypes.string,

  /** Children to be displayed in the menu. */
  children: _propTypes.node,

  /** Initial opened or closed state */
  open: _propTypes.bool
};
CollapsibleSidebar.defaultProps = {
  open: false
};
var _default = CollapsibleSidebar;
exports.default = _default;